<div class="group-tutorization">
  <div class="mars-tutorization">
    <mat-tab-group class="sub-tab-group" animationDuration="0ms" disableRipple="true">
      <mat-tab *lmsProfileGuard="'tutorization.questions'" label="config">
        <ng-template mat-tab-label>{{ 'tutorization.questions' | translate }}</ng-template>
        <ng-template matTabContent>
          <div class="lms-toolbar">
            <div></div>
            <div class="lms-toolbar__block">
              <lms-search-field [listId]="groupQuestionsListId"></lms-search-field>
              <lms-items-count-selector
                class="hide-on-med-and-down"
                [listId]="groupQuestionsListId"
              ></lms-items-count-selector>
              <div class="lms-toolbar__item" *lmsProfileGuard="'groups.activity.download'">
                <gl-button
                  icon
                  icon-center="glicon-download"
                  (onClick)="marsQuestions.download()"
                  title="{{ 'actions.download' | translate }}"
                >
                </gl-button>
              </div>
              <div class="lms-toolbar__item" *lmsProfileGuard="'questions.create'">
                <gl-button
                  color-primary
                  [text]="'actions.createQuestion' | translate"
                  [routerLink]="['/groups-tutorization/group-questions/new']"
                  [queryParams]="{ groupId: group.id }"
                  title="{{ (endDate < now ? null : 'questions.create') | translate }}"
                  [disabled]="endDate < now"
                >
                </gl-button>
              </div>
            </div>
          </div>
          <div class="row">
            <lms-mars1-questions
              #marsQuestions
              [listId]="groupQuestionsListId"
              [options]="{ filters: filters, sort: '-created_at' }"
              [group]="group"
            ></lms-mars1-questions>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab *lmsProfileGuard="'tutorization.mis'" label="translate">
        <ng-template mat-tab-label>{{ 'tutorization.messages' | translate }}</ng-template>
        <ng-template matTabContent>
          <div class="row">
            <lms-mars1-messages
              [listId]="groupMessagesListId"
              [options]="{ filters: filters }"
              [group]="group"
            ></lms-mars1-messages>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab *lmsProfileGuard="'tutorization.debates'" label="translate">
        <ng-template mat-tab-label>{{ 'tutorization.discussion' | translate }}</ng-template>
        <ng-template matTabContent>
          <div class="tools margin-none">
            <lms-search-field [listId]="groupDebatesListId"></lms-search-field>
            <lms-items-count-selector
              class="hide-on-med-and-down"
              [listId]="groupDebatesListId"
            ></lms-items-count-selector>
          </div>
          <div class="row">
            <lms-mars1-debates
              [listId]="groupDebatesListId"
              [options]="{ filters: filters, sort: '-created_at' }"
              [groupId]="group.id"
            ></lms-mars1-debates>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
